import React from "react";
import * as PropTypes from "prop-types";
import ReactDOM from 'react-dom';


/**
 * A whole lot of hoopla to render a zoomable image (so that the image doesn't take over if too large).
 * If you don't need this, just render an image and an anchor
 */
export default class ActivityStreamImageAttachment extends React.Component {

  static propTypes = {
    link: PropTypes.string,
    img: PropTypes.string.isRequired,
    maxWidth: PropTypes.number.isRequired,
    maxHeight: PropTypes.number.isRequired
  };

  static defaultProps = {
    maxWidth: 500,
    maxHeight: 300
  };

  state = {
    shrunk: true,
    naturallyLarger: false,
    naturalHeight: undefined,
    naturalWidth: undefined
  };

  setImgRef = (ref) => {
    const imgDom = ReactDOM.findDOMNode(ref);
    if (imgDom) {
      const setNaturallyLarger = () => {
        const imgDom = ReactDOM.findDOMNode(ref)
        const naturalHeight = imgDom.naturalHeight
        const naturalWidth = imgDom.naturalWidth
        const naturallyLarger = naturalWidth > this.props.maxWidth || naturalHeight > this.props.maxHeight
        this.setState({naturallyLarger, naturalHeight, naturalWidth})
      };
      if (imgDom.complete) {
        setNaturallyLarger()
      } else {
        imgDom.addEventListener('load', setNaturallyLarger)
      }

    }
  };

  render() {
    const {link, img, maxWidth, maxHeight} = this.props;
    const {naturallyLarger, naturalHeight, naturalWidth, shrunk} = this.state;

    const style = {
      transition: 'max-height 300ms ease-in-out',
      objectFit: 'contain',
      width: shrunk ? Math.min(naturalWidth || maxWidth, maxWidth) : naturalWidth,
      maxWidth: '100%',
      maxHeight: shrunk ? Math.min(naturalHeight || maxHeight, maxHeight) : naturalHeight
    };
    return <div style={{position:'relative', display: 'inline-block', maxWidth: '100%'}}>
      <a href={link || img} target="_blank">
        <img
          style={style}
          ref={this.setImgRef}
          src={img}/>
      </a>
      {
        !naturallyLarger ? undefined : <a
          tabIndex="-1"
          style={{position: 'absolute', bottom: 10, right: 10, opacity: 0.7}}
          className="btn btn-sm btn-light"
          onClick={() => this.setState({shrunk: !shrunk})}>
            <span className={`ss ${shrunk ? 'ss-zoom' : 'ss-zoomout'}`} />
        </a>
      }
    </div>
  }
}
